import {
  getFirestore,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";

export const ItemEditwsqry = async (data) => {
 
  if (!data?.itemname) {
    return { success: false, error: "Missing name." };
  }
 
  if (!data?.itemuid) {
    return { success: false, error: "Missing ItemUID." };
  }
  
  try {
  
 
    const docRef = doc(db, "projectstaskitem",data.itemuid);
    const timestamp = Timestamp.now();
    const savequery = {
      ...data, 
      update_date_time: timestamp,  
    };

    await updateDoc(docRef, savequery);
    return { success: true };

  } catch (err) {
    console.error("Error creating task:", err);
    return { success: false, error: err.message || "Unknown error occurred" };
  }
};
